import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Channels from '../views/Channels.vue'
import Daily from '../views/Daily.vue'
import Sentence from '../components/Sentence.vue'
import Course from '../views/Course.vue'
import FirstLogin from '../views/FirstLogin.vue'
import UpdatedPassword from '../views/UpdatedPassword.vue'
import ChannelLesson from '../views/ChannelLesson.vue'
import CourseLesson from '../views/CourseLesson.vue'
import Login from '../views/Login.vue'
import Personal from '../views/Personal.vue'
import Examination from '../views/Examination.vue'
import ExamArea from '../components/ExamArea.vue'
import Record from '../components/Record.vue'
import Target from '../components/Target.vue'
import Collections from '../components/Collections.vue'
import Raiders from '../views/Jlpt/Raiders.vue'
import DetailAnswer from '../views/DetailAnswer.vue'
import Director from '../views/Director/Director.vue'
import Overview from '../views/Director/Overview.vue'
import PersonalDetail from '../views/Director/PersonalDetail.vue'
import Talk from '../views/Talk.vue'
import Search from '../views/Search.vue'
import NewsLetter from '../views/NewsLetter.vue'
import Challenge from '../views/Challenge.vue'
import FAQ from '../views/FAQ.vue'
import AiHelperLayout from '@/views/AiHelper/Layout.vue'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: FAQ,
    meta: { requiresAuth: false }
  },
  {
    path: '/first-login',
    name: 'First-login',
    component: FirstLogin,
    meta: { requiresAuth: false }
  },
  {
    path: '/reset_password',
    name: 'Reset-password',
    component: UpdatedPassword,
    meta: { requiresAuth: false }
  },
  {
    path: '/updated-password',
    name: 'Updated-password',
    component: UpdatedPassword,
    meta: { requiresAuth: true }
  },
  {
    path: '/daily',
    name: 'Daily',
    component: Daily,
    children: [
      { path: 'sentence', name: 'Sentence', component: Sentence }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/channels/:channel',
    name: 'Channels',
    component: Channels,
    meta: { requiresAuth: true }
  },
  {
    path: '/lesson/:lessonId',
    name: 'ChannelLesson',
    component: ChannelLesson,
    meta: { requiresAuth: true }
  },
  {
    path: '/course/:channel',
    name: 'Course',
    component: Course,
    meta: { requiresAuth: true }
  },
  {
    path: '/course-lesson/:lesson/:courseId',
    name: 'CourseLesson',
    component: CourseLesson,
    meta: { requiresAuth: true }
  },
  {
    path: '/jlpt/raiders',
    name: 'Raiders',
    component: Raiders,
    meta: { requiresAuth: true }
  },
  {
    path: '/biz-talk',
    name: 'Biz-talk',
    component: Talk,
    meta: { requiresAuth: true }
  },
  {
    path: '/newsletter',
    name: 'NewsLetter',
    component: NewsLetter,
    meta: { requiresAuth: true }
  },
  {
    path: '/personal',
    name: 'Personal',
    component: Personal,
    meta: { requiresAuth: true },
    children: [
      { path: 'target', name: 'Target', component: Target },
      { path: 'collections', name: 'Collections', component: Collections },
      { path: 'exam', name: 'Exam-area', component: ExamArea },
      { path: 'record', name: 'Record', component: Record }
    ]
  },
  {
    path: '/search',
    name: 'Search',
    component: Search,
    props: route => ({ query: route.query.q }),
    meta: { requiresAuth: true }
  },
  {
    path: '/challenge',
    name: 'Challenge',
    component: Challenge,
    meta: { requiresAuth: true }
  },
  {
    path: '/examination/:examId/:viewId',
    name: 'Examination',
    component: Examination,
    meta: { requiresAuth: true }
  },
  {
    path: '/detailAnswer/:examId/:viewId/:recordId?',
    name: 'DetailAnswer',
    component: DetailAnswer,
    meta: { requiresAuth: true }
  },
  {
    path: '/director',
    name: 'Director',
    component: Director,
    children: [
      { path: 'overview/:type/:groupId?', name: 'Overview', component: Overview },
      { path: 'personal-detail/:type/:groupId?', name: 'PersonalDetail', component: PersonalDetail }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/AI_assistant',
    name: 'AI_assistant',
    component: AiHelperLayout,
    children: [
      { path: 'generate/:aiType', name: 'ai_assistantMain', component: () => import('@/views/AiHelper/Speech.vue') },
      { path: 'chat/:promptId?', name: 'chat', component: () => import('@/views/AiHelper/ChatContent.vue') }
    ],
    meta: { requiresAuth: true }
  },
  { path: '*', redirect: { name: 'Home' } }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(function (to, from, next) {
  setTimeout(() => {
    window.scrollTo(0, 0)
  }, 100)
  next()
})
export default router
